<template>
  <div>
    <v-card class="card-shadow border-radius-xl pa-6">
      <div class="pb-4">
        <h6 class="text-typo text-h6 font-weight-bold">Import XLS</h6>
      </div>
      <v-row v-if="loading">
        <v-col cols="12">
          <p class="text-center">
            La mise à jour peut prendre quelques secondes.
          </p>
          <p class="text-center">
            Veuillez rafraichir la page pour visualiser vos modifications.
          </p>
          <BtnWhite
            btnTitle="Fermer et rafraichir la page"
            @clicked="closeRefresh"
          ></BtnWhite>
        </v-col>
      </v-row>
      <div v-else>
        <v-row>
          <v-col cols="12">
            <BtnWhite
              btnTitle="Télécharger un model xlsx"
              @clicked="dowloadTemplate"
            ></BtnWhite>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <form class="mb-4">
              <input
                type="file"
                name="uploadFile"
                id="uploadFile"
                accept=".xlsx"
                @change="updateFileToUpload"
                required
                hidden
              />
              <label
                for="uploadFile"
                class="font-weight-bolder py-4 px-8 mt-auto import-btn"
                >IMPORTER UN FICHIER EXCEL XLSX</label
              >
              <p v-if="spotExcel" class="mt-4 text-center">
                Le fichier sélectionné est:
                <span class="font-weight-bolder">{{ spotExcel.name }}</span>
              </p>
            </form>
            <v-row class="d-flex align-center justify-space-between">
              <v-col cols="6">
                <BtnWhite btnTitle="Annuler" @clicked="closeRefresh"></BtnWhite>
              </v-col>
              <v-col cols="6">
                <BtnBlue
                  btnTitle="Envoyer"
                  :disabled="canUploadFile"
                  @clicked="postXLS"
                ></BtnBlue>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import BtnBlue from "../common/BtnBlue.vue";
import BtnWhite from "../common/BtnWhite.vue";
import Auth from "@aws-amplify/auth";

export default {
  name: "ImportXLS",

  components: {
    BtnBlue,
    BtnWhite,
  },

  data() {
    return {
      loading: false,
      spotExcel: null,
    };
  },

  computed: {
    canUploadFile() {
      const allowedTypes = ["xls", "xlsx"];
      return (
        this.spotExcel !== null &&
        allowedTypes.includes(this.spotExcel.name.split(".").slice(-1)[0])
      );
    },
  },

  methods: {
    dowloadTemplate() {
      fetch(
        "https://s3.eu-central-1.amazonaws.com/dynapark.assets/templates-excel/spots-template.xlsx"
      )
        .then((res) => res.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = "model_place.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          console.error("Something wrong during download spot model xlsx", err);
        });
    },

    async postXLS() {
      this.loading = true;
      const currentSession = await Auth.currentSession();
      const token = currentSession.idToken.jwtToken;
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append(
        "Content-Type",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      const file = this.spotExcel;
      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: file,
        redirect: "follow",
      };
      const ets = this.$store.getters.selectedClient.enterpriseId;
      const parkingId = this.$route.params.id;
      fetch(
        `https://clients.dynapark.io/v1/spotsimport/${ets}/${parkingId}/spot.xlsx`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => console.log("RESULT:", result))
        .catch((error) => console.error("error during xlsx upload", error));
    },

    updateFileToUpload(evt) {
      this.spotExcel = evt.target.files[0];
    },

    closeRefresh() {
      this.loading = false;
      this.spotExcel = null;
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
.import-btn {
  padding: 6px;
  border: 1px solid #344767;
  color: #344767;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  transform: scale(1);
  transition: transform 250ms ease-out;
}

.import-btn:hover {
  cursor: pointer;
  border: 1px solid gray;
  transform: scale(1.02);
  transition: transform 250ms ease-out;
  border: 1px solid #344767;
  color: #344767;
  -webkit-box-shadow: 0 3px 5px -1px rgb(0 0 0 / 9%),
    0 2px 3px -1px rgb(0 0 0 / 7%);
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 9%), 0 2px 3px -1px rgb(0 0 0 / 7%);
}
</style>
